<template>
  <div @click="openDetails">
    <travel-service-order-item-car-chip
      v-if="travelServiceOrderItem.type === 'car'"
      :travel-service-order-item="travelServiceOrderItem"
      :textColor="textColor"
      :color="color"
      class="travel-service-chips"
      :text="text"
    />
    <travel-service-order-item-hotel-chip
      v-else-if="travelServiceOrderItem.type === 'hotel'"
      :travel-service-order-item="travelServiceOrderItem"
      :textColor="textColor"
      :color="color"
      class="travel-service-chips"
      :text="text"
    />
    <travel-service-order-item-insurance-chip
      v-else-if="travelServiceOrderItem.type === 'insurance'"
      :travel-service-order-item="travelServiceOrderItem"
      :text-color="textColor"
      :color="color"
      class="travel-service-chips"
      :text="text"
    />
    <travel-service-order-item-flight-chip
      v-else-if="travelServiceOrderItem.type === 'flight'"
      :travel-service-order-item="travelServiceOrderItem"
      :textColor="textColor"
      :color="color"
      class="travel-service-chips"
      :text="text"
    />
    <travel-service-order-item-rail-chip
      v-else-if="travelServiceOrderItem.type === 'rail'"
      :travel-service-order-item="travelServiceOrderItem"
      :textColor="textColor"
      :color="color"
      class="travel-service-chips"
      :text="text"
    />
    <travel-service-order-item-other-chip
      v-else
      :travel-service-order-item="travelServiceOrderItem"
      :textColor="textColor"
      :color="color"
      class="travel-service-chips"
      :text="text"
    />
  </div>
</template>

<script>
import TravelServiceOrderItemCarChip from "./TravelServiceOrderItemCarChip";
import TravelServiceOrderItemHotelChip from "./TravelServiceOrderItemHotelChip";
import TravelServiceOrderItemFlightChip from "./TravelServiceOrderItemFlightChip";
import TravelServiceOrderItemRailChip from "./TravelServiceOrderItemRailChip";
import { singleServiceOrderStatus } from "../../../staticData/ServiceOrder";
import TravelServiceOrderItemOtherChip from "./TravelServiceOrderItemOtherChip";
import TravelServiceOrderItemInsuranceChip from "./TravelServiceOrderItemInsuranceChip";

export default {
  name: "TravelServiceOrderItemChip",
  components: {
    TravelServiceOrderItemInsuranceChip,
    TravelServiceOrderItemOtherChip,
    TravelServiceOrderItemRailChip,
    TravelServiceOrderItemFlightChip,
    TravelServiceOrderItemHotelChip,
    TravelServiceOrderItemCarChip
  },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    clickUrl: {
      required: false,
      default: "/travel-service/item-details/"
    },
    newTab: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  computed: {
    singleServiceOrderStatus,
    textColor() {
      return this.singleServiceOrderStatus.find(v => v.value === this.travelServiceOrderItem.status).textColor;
    },
    color() {
      return this.singleServiceOrderStatus.find(v => v.value === this.travelServiceOrderItem.status).color;
    },
    text() {
      return this.singleServiceOrderStatus.find(v => v.value === this.travelServiceOrderItem.status).text;
    }
  },
  methods: {
    openDetails() {
      let url = this.clickUrl + this.travelServiceOrderItem.id;
      if (this.newTab) {
        window.open(url, "_blank");
      } else {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style>
.travel-service-chips {
  /*max-width: 150px;*/
  height: auto !important;
}
.travel-service-chips .v-chip__content {
  height: auto;
  white-space: normal;
}
</style>
